import apiUnsecure from '../../services/apiUnsecure'

const AuthService = {
  async sendResetPasswordEmail(email) {
    const res = await apiUnsecure.get(`/password/forgot?username=${email}`)
    return res.data
  },
}

export default AuthService
